import { render } from "./BlogFour.vue?vue&type=template&id=651c0bc1&scoped=true"
import script from "./BlogFour.vue?vue&type=script&lang=js"
export * from "./BlogFour.vue?vue&type=script&lang=js"

import "./BlogFour.vue?vue&type=style&index=0&id=651c0bc1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651c0bc1"]])

export default __exports__